import { useAuth } from "@/contexts/AuthContext";

export function FeedbackPage() {
  const { user } = useAuth();

  // Base Google Form URL with embedded parameter
  const baseUrl = "https://docs.google.com/forms/d/e/1FAIpQLScyByQy-LMx5CqTcC_HE9g2ofBt4JgkUWKz01hOphelpMEYMw/viewform?embedded=true";

  // Pre-fill email if user is logged in
  const formUrl = user?.email
    ? `${baseUrl}&entry.1045781291=${encodeURIComponent(user.email)}`
    : baseUrl;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Feedback</h1>
        <p className="text-muted-foreground">
          Help us improve Shoresh — report bugs, request features, or share your thoughts
        </p>
      </div>

      <div className="rounded-lg border bg-card overflow-hidden">
        <iframe
          src={formUrl}
          width="100%"
          height="800"
          frameBorder="0"
          title="Feedback Form"
          className="bg-white"
        >
          Loading form...
        </iframe>
      </div>
    </div>
  );
}
